import { render, staticRenderFns } from "./MainNavbar.vue?vue&type=template&id=0f2df1ea&scoped=true&"
import script from "./MainNavbar.vue?vue&type=script&lang=ts&"
export * from "./MainNavbar.vue?vue&type=script&lang=ts&"
import style0 from "./MainNavbar.vue?vue&type=style&index=0&id=0f2df1ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2df1ea",
  null
  
)

export default component.exports